export const GET_ALERT_LIST = 'src/Components/Sidebar/action/Get_alert_list'
export const GET_ALERT_LIST_SUCCESS = 'src/Components/Sidebar/action/Get_alert_list_success'
export const GET_ALERT_LIST_FAILURE = 'src/Components/Sidebar/action/Get_alert_list_failure'
export const GET_GENERAL_NEWS_LIST = 'src/Components/Sidebar/action/Get_general_news_list'
export const GET_GENERAL_NEWS_LIST_SUCCESS = 'src/Components/Sidebar/action/Get_general_news_list_success'
export const GET_GENERAL_NEWS_LIST_FAILURE = 'src/Components/Sidebar/action/Get_general_news_list_failure'

export const getAlertList = () => {
    return {
        type: GET_ALERT_LIST
    }
}

export const getAlertListSuccess = (data) => {
    return {
        type: GET_ALERT_LIST_SUCCESS,
        data
    }
}

export const getAlertListFailure = (data) => {
    return {
        type: GET_ALERT_LIST_FAILURE,
        data
    }
}

export const getGeneralNewsList = () => {
    return {
        type: GET_GENERAL_NEWS_LIST
    }
}

export const getGeneralNewsListSuccess = (data) => {
    return {
        type: GET_GENERAL_NEWS_LIST_SUCCESS,
        data
    }
}

export const getGeneralNewsListFailure = (data) => {
    return {
        type: GET_GENERAL_NEWS_LIST_FAILURE,
        data
    }
}
export const UPDATE_READ_STATUS = 'src/Corporate/Sidebar/action/Update_Read_status';
export const UPDATE_READ_STATUS_SUCCESS = 'src/Corporate/Sidebar/action/Update_Read_status_Success';
export const UPDATE_READ_STATUS_FAILURE = 'src/Corporate/Sidebar/action/Update_Read_status_Failure';
export const updateReadStatus = (data) => {
    return {
        type: UPDATE_READ_STATUS,
        data
    }
}
export const updateReadStatusSuccess = (data) => {
    return {
        type: UPDATE_READ_STATUS_SUCCESS,
        data
    }
}
export const updateReadStatusFailure = (data) => {
    return {
        type: UPDATE_READ_STATUS_FAILURE,
        data
    }
}
